import axios from 'axios';

import type { PaginatedApiResponse } from 'api/_types';
import type { CoreService, CoreServiceDTO } from 'api/coreService/coreService.types';
import createUrlWithParams from 'helpers/createUrlWithParams/createUrlWithParams';

import { endpoint } from '../coreService';
import { parseServicesForFE } from '../parseServicesForFE/parseServicesForFE';

interface Params {
  patientId: number;
  types?: string[];
  payers: (string | number)[];
  limit?: number;
  pro?: boolean;
  policyId?: number;
}

type GetServicesFromSubtypeQuery = () => Promise<CoreService[]>;

export const getServicesFromSubtype =
  ({ patientId, types, payers, limit = 25, pro, policyId }: Params): GetServicesFromSubtypeQuery =>
  async () => {
    const { data } = await axios.get<GetServicesFromSubtypeQuery, PaginatedApiResponse<CoreServiceDTO>>(
      createUrlWithParams({
        url: endpoint,
        params: {
          patient_id: patientId,
          limit,
          type: types,
          payer: payers,
          pro,
          policy: policyId,
        },
      }),
    );

    return parseServicesForFE(data.results);
  };
